import React, { createContext, useState, useEffect } from "react";
import { ensureSessionForUser } from "../utils/sessionManager";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [sessionId, setSessionId] = useState(() => {
    return localStorage.getItem("sessionId") || null;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
      
    } else {
      localStorage.removeItem("user");
    }
  }, [user]);

  useEffect(() => {
    if (sessionId) {
      localStorage.setItem("sessionId", sessionId);
    } else {
      localStorage.removeItem("sessionId");
    }
  }, [sessionId]);

  const login = async (userData) => {
    setUser(userData);

    try {
    

      const sid = await ensureSessionForUser(userData.userId);
 
      setSessionId(sid);
    } catch (err) {
    
    }
  };

  const logout = () => {
    setUser(null);
    setSessionId(null);
  };

  const signup = (userData) => {
    setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, sessionId, login, logout, signup }}>
      {children}
    </AuthContext.Provider>
  );
}
